import PartnerAddressBook from '../../pages/partner/addressbook';
import PartnerCalendar from '../../pages/partner/calendar/calendar';
import PartnerCampaign from '../../pages/partner/campaign/containers/campaign';
import PartnerCampaigns from '../../pages/partner/campaign/containers/campaigns';
import PartnersContact from '../../pages/partner/contacts/containers/contact';
import PartnersContacts from '../../pages/partner/contacts/containers/contacts';
import PartnerHelpCenter from '../../pages/partner/helpcenter';
import PartnerOneUser from '../../pages/partner/oneuser/containers/one-user';
import PartnerOneUsers from '../../pages/partner/oneuser/containers/one-users';
import PartnerProfile from '../../pages/partner/profile';
import PartnerWorkingInProgress from '../../pages/partner/wip';
import { RoleGuard } from '../guards';



export const PartnerRoutes = () => {

	return ([
		
		// Start - Profile
		{ path: 'profile', element: <RoleGuard roles={["Partner"]}><PartnerProfile /></RoleGuard>},
		{ path: 'helpcenter', element: <RoleGuard roles={["Partner"]}><PartnerHelpCenter /></RoleGuard>},
		{ path: 'address', element: <RoleGuard roles={["Partner"]}><PartnerAddressBook /></RoleGuard>},
		{ path: 'wip', element: <RoleGuard roles={["Partner"]}><PartnerWorkingInProgress /></RoleGuard>},
		{ path: 'oneuser', element: <RoleGuard roles={["Partner"]}><PartnerOneUsers /></RoleGuard>},
		{ path: 'oneuser/:id', element: <RoleGuard roles={["Partner"]}><PartnerOneUser /></RoleGuard>},
		{ path: 'contacts', element: <RoleGuard roles={["Partner"]}><PartnersContacts /></RoleGuard>},
		{ path: 'contacts/:id', element: <RoleGuard roles={["Partner"]}><PartnersContact /></RoleGuard>},
		{ path: 'campaign', element: <RoleGuard roles={["Partner"]}><PartnerCampaigns /></RoleGuard>},
		{ path: 'campaign/:id', element: <RoleGuard roles={["Partner"]}><PartnerCampaign /></RoleGuard>},
		{ path: 'calendar', element: <RoleGuard roles={["Partner"]}><PartnerCalendar /></RoleGuard>},


      	])	
};
